import link from './fragment-link'
import seo from './fragment-seo'

export default /* graphql */ `
query($preview: Boolean, $locale: String, $slug: String, $sectionsSkip: Int) {
  modularPageCollection(preview: $preview, locale: $locale, limit: 1, where:{slug: $slug}) {
    items {
      sys { id }
      title
      seo { ...seo }
      slug
      eyebrow
      headline
      copy { json }
      image
      useAnchorNav
      enableSidePanel
      sidebarCopy {json}
      contactName
      contactEmail
      contactNumber
      link
      sectionsCollection(limit: 12, skip: $sectionsSkip) {
        total
        items {
          ... on ModuleText {
            __typename
            sys { id }
            id
            copy {
              json
            }
            callToAction {
              ...link
            }
            isHtmlElement
          }
          ... on ModuleVideo {
            __typename
            sys { id }
            video
            youtubeId
            thumbnail {
              title
              url(transform: {
                width: 1440,
                format: JPG,
                quality: 90
              })
            }
            download
          }

          ... on ModuleQuote {
            __typename
            sys { id }
            quote
            attribution
          }

          ... on ModuleImageGallery {
            __typename
            sys { id }
            images
          }

          ... on ModuleFaq {
            __typename
            sys { id }
            itemsCollection {
              total
              items {
                sys { id }
                title
                content {
                  json
                }
                callToAction {
                  ...link
                }
              }
            }
          }

          ... on ModuleContentCarousel {
            __typename
            sys { id }
            itemsCollection {
              total
              items {
                sys { id }
                title
                copy
                thumbnail {
                  title
                  url(transform: {
                    width: 628,
                    height: 420,
                    resizeStrategy: THUMB,
                    resizeFocus: CENTER,
                    format: JPG,
                    quality: 90
                  }) 
                }
              }
            }
          }

          ... on ModuleContentGrid {
            __typename
            sys { id }
            itemsCollection {
              total
              items {
                sys { id }
                title
                copy
                thumbnail {
                  title
                  url(transform: {
                    width: 628,
                    height: 420,
                    resizeStrategy: THUMB,
                    resizeFocus: CENTER,
                    format: JPG,
                    quality: 90
                  }) 
                }
                callToAction {
                  ...link
                }
              }
            }
          }
            ... on ModuleContentVerticalGrid {
            __typename
            sys { id }
            itemsCollection {
              total
              items {
                sys { id }
                title
                copy
                thumbnail {
                  title
                  url(transform: {
                    width: 628,
                    height: 420,
                    resizeStrategy: THUMB,
                    resizeFocus: CENTER,
                    format: JPG,
                    quality: 90
                  }) 
                }
                callToAction {
                  ...link
                }
                additionalInformation {
                  json
                }
              }
            }
          }

          ... on ModuleNavigationAnchor {
            __typename
            sys { id }
            title
            slug
          }
          
          ... on ModuleStripePayment {
            __typename
            sys { id }
            title
            formTitle
            isPaymentEnabled
            stripeKey
            eventId
            eventPrice
            minTicketQuantity
            maxTicketQuantity
          }  
                  
          ... on ModuleSalesforceSignUp {
            __typename
            sys { id }
            title
            formTitle
            isPaymentEnabled
            salesforceCampaignId
            price
            stripeKey
            formFields
            
          }

          ... on ModuleCallToActionBanner {
            __typename
            sys { id }
            title
            copyString: copy
            cta {
              ...link
            }
          }
          ... on ModuleImage {
            __typename
            sys { id }
            link
            thumbnail {
              title
              url(transform: {
                width: 1440,
                format: JPG,
                quality: 90
              })
            }
          }
        }
      }
    }
    total
  }
}

${link}
${seo}
`
